<div>
  <div *ngIf="!components.length" class="bordered">
    <div class="empty-info text-center">
      Nejsou k dispozici žádné dokumenty
    </div>
  </div>

  <div *ngIf="components.length" class="mb-30">
    <div class="mb-20">
      <span class="pr-10">
        <gmt-checkbox [gmtChecked]="systemComponents" (click)="systemComponents = !systemComponents"></gmt-checkbox> Zobrazovat systémové komponenty
      </span>
      <span class="pr-10">
        <gmt-checkbox [gmtChecked]="canceledComponents" (click)="canceledComponents = !canceledComponents"></gmt-checkbox> Zobrazovat zrušené komponenty
      </span>
    </div>
    <table class="bordered">
      <thead>
        <tr>
          <td class="first-col"></td>
          <td (click)="onComponentSort('baseName')">
            <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'baseName' }">Název komponenty (souboru)</span>
          </td>
          <td (click)="onComponentSort('attachmentType')">
            <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'attachmentType' }">Typ komponenty</span>
          </td>
          <td (click)="onComponentSort('sourceType')">
            <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'sourceType' }">Způsob vytvoření</span>
          </td>
          <td (click)="onComponentSort('timestamp')">
            <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'timestamp' }">Vytvořeno</span>
          </td>
          <td (click)="onComponentSort('updatedTimestamp')">
            <span class="label sort-{{ componentSortOrder.direction }}" [ngClass]="{ 'sort-active': componentSortOrder.sortBy === 'updatedTimestamp' }">Změněno</span>
          </td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let component of components">
          <tr *ngIf="!shouldHideComponent(component)" class="component-row" [ngClass]="{ 'txt-cancelled': component.cancelled }">
            <td class="first-col">
              <i *ngIf="fileType(component, 'pdf')" class="fa fa-lg fa-blue fa-file-pdf-o"></i>
              <i *ngIf="fileType(component, 'word')" class="fa fa-lg fa-blue fa-file-word-o"></i>
              <i *ngIf="fileType(component, 'excel')" class="fa fa-lg fa-blue fa-file-excel-o"></i>
              <i *ngIf="fileType(component, '')" class="fa fa-lg fa-blue fa-file"></i>
            </td>
            <td>{{ component.baseName }}</td>
            <td>
              <span *ngIf="component.attachmentType">{{ { type: component.attachmentType } | attachmentType : 'title' }}</span>
              <span *ngIf="!component.attachmentType" class="txt-muted"><i class="fa fa-exclamation-triangle color-red"></i> Je potřeba vybrat typ komponenty</span>
            </td>
            <td>{{ component.sourceType | documentSourceTypeName }}</td>
            <td class="small-padding">
              <span class="txt-small">{{ component.timestamp | date : 'short' }}</span><br>
              <span class="txt-small">{{ component.createdUser | username:false :false }}</span>
            </td>
            <td class="small-padding">
              <span class="txt-small">{{ component.updatedTimestamp | date : 'short' }}</span><br>
              <span class="txt-small">{{ component.updatedUser | username:false :false }}</span>
            </td>
            <td>
              <div class="text-right">
                <span *ngIf="!component.cancelled && mapEnabled && fileType(component, 'vfk')" class="action-button">
                  <a uiSref="symap.project.map" [uiParams]="{ document: component.id, tool: 'gp-vfk' }" title="Náhled VFK v mapě" class="mr-10" target="_blank">
                    <i class="fa fa-map fa-lg"></i>
                  </a>
                </span>

                <span *ngIf="!component.cancelled && component.canViewPDF" class="action-button">
                  <a href="{{ getComponentUrl(component) }}" title="Náhled" target="_blank">
                    <i class="fa fa-lg fa-eye"></i>
                  </a>
                </span>

                <span *ngIf="canEdit && !component.cancelled" class="action-button">
                  <a (click)="onUpdateComponent(component, component.document)" [tooltip]="'Metadata komponenty / poznámka'"><i class="fa fa-lg fa-info-circle"></i></a>
                </span>

                <span *ngIf="!component.cancelled" class="action-button">
                  <a href="{{restBaseUrl}}/documents/{{component.document.id}}/components/{{component.id}}/content?t={{authToken}}" title="Stáhnout">
                    <i class="fa fa-lg fa-download"></i>
                  </a>
                </span>

                <span *ngIf="canEditComponent(component)" class="action-button">
                  <gmt-button [clickAction]="onEditComponent(component)" [gmtDisabled]="!!component.editLock" [tooltip]="component.editUser ? ('Edituje: ' + (component.editUser | username: false:false)) : 'Editace'" [showTitle]="false">
                    <i class="fa fa-lg fa-pencil"></i>
                  </gmt-button>
                </span>

                <span *ngIf="canVersionComponent(component)" class="action-button">
                  <a (click)="onVersionComponent(component)" title="Vložit novou verzi komponenty EPD"><i class="fa fa-lg fa-upload"></i></a>
                </span>

                <span *ngIf="canCancelComponent(component)" class="action-button">
                  <a (click)="onCancelComponent(component)" title="Zneplatnit"><i class="fa fa-lg fa-trash-o black"></i></a>
                </span>
              </div>
            </td>
          </tr>
          <tr *ngIf="!shouldHideComponent(component) && component.note" [ngClass]="{ 'txt-cancelled': component.cancelled }">
            <td></td>
            <td colspan="6">
              <div class="flexbox-container">
                <div class="mr-5">Poznámka:</div>
                <div *ngIf="!component.noteOpened">
                  {{ component.note | stripHtml | truncate }}
                  <a (click)="component.noteOpened = !component.noteOpened; $event.preventDefault();"><i class="fa fa-eye"></i></a>
                </div>
                <div *ngIf="component.noteOpened" class="flexbox-container full-width">
                  <div class="bordered full-width">
                    <ck-content [content]="component.note"></ck-content>
                  </div>
                  <a (click)="component.noteOpened = !component.noteOpened; $event.preventDefault();" class="ml-5"><i class="fa fa-times"></i></a>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
